import axiosInstance from '../common/axiosInstance'
import { API_ROUTES } from '../common/routes'

export const postCountinueExtraTime = (payload) => axiosInstance.post(API_ROUTES.Live.ContinueExtraTime, payload)
